// extracted by mini-css-extract-plugin
module.exports = {"loadingIcon":"loading-icon_loadingIcon__NAwrQ","loading":"loading-icon_loading__dGt_t"};